<template>
  <b-navbar toggleable="lg" type="warning" variant="white">
    <b-navbar-brand to="/"
      ><img src="@/assets/logo-small.svg" alt="Logo MyBooks"
    /></b-navbar-brand>

    <b-navbar-toggle target="nav-collapse" class="text-red"
      >☰
      <template v-slot:default="{ expanded }">
        <b-icon v-if="expanded" icon="x"></b-icon>
        <b-icon v-else icon="list"></b-icon>
      </template>
    </b-navbar-toggle>

    <b-collapse id="nav-collapse" class="ml-auto" is-nav>
      <b-navbar-nav class="ml-auto">
        <!-- <b-nav-item to="/books">Books</b-nav-item> -->
        <b-nav-item v-if="isLoggedIn" to="/users">Users</b-nav-item>
        <b-dropdown
          v-if="this.$store.getters.myUnreadMessagesCount && isLoggedIn"
          variant="link"
          toggle-class="text-decoration-none"
          no-caret
          right
        >
          <template v-slot:button-content>
            <b-icon icon="bell"></b-icon>
            <span class="badge badge-notification badge-pill badge-danger">{{
              $store.getters.myUnreadMessagesCount(user.uid)
            }}</span>
          </template>
          <div
            v-for="message in this.$store.getters.myUnreadMessages(user.uid)"
            :key="message.id"
          >
            <b-dropdown-item class="notification-popup-message" href="#">{{
              message.message
            }}</b-dropdown-item>
          </div>
        </b-dropdown>
      </b-navbar-nav>
      <b-navbar-nav>
        <b-nav-item
          class="btn btn-primary btn-sm"
          v-if="isLoggedIn"
          to="/scanner"
          >Add Book</b-nav-item
        >
        <b-nav-item v-if="!isLoggedIn" to="/login">Login</b-nav-item>
        <b-nav-item v-if="!isLoggedIn" to="/signup">Signup</b-nav-item>
        <b-nav-item-dropdown right v-if="isLoggedIn">
          <template v-slot:button-content>
            <span class="avatar"></span>
          </template>
          <b-dropdown-item to="/profil"
            >{{ user.displayName }}s Profil</b-dropdown-item
          >
          <b-dropdown-item @click="logOut()">Logout</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
// @ is an alias to /src
import firebase from 'firebase';

export default {
  name: 'Home',
  data() {
    return {
      expanded: null,
      // isLoggedIn: false,
      user: {
        displayName: '',
      },
    };
  },
  created() {
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        this.user = user;
      } else {
        this.user = null;
      }
    });
    // this.isLoggedIn = this.$store.state.isLoggedIn;
    // console.log(this.isLoggedIn);
  },
  computed: {
    isLoggedIn() {
      return this.$store.state.isLoggedIn;
    },
  },
  methods: {
    logOut() {
      console.log('logOut CLicked');
      firebase
        .auth()
        .signOut()
        .then(() => {
          firebase.auth().onAuthStateChanged(() => {
            this.$router.push('/login');
            this.$store.dispatch('setloggedInStatus', false);
          });
        });
    },
  },
};
</script>
